module.exports = __webpack_public_path__ + "static/media/guitarDrive.0ed4272e.png";